import { AxiosInstance } from 'axios'
import { ApiResult, idItem, Pagging } from '../server.api'

export default class NewsletterApi {
  instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async search(params: NewsletterFileSearch): Promise<ApiResult<Pagging<NewsletterFileBase>>> {
    return this.instance.post('/NewsletterFile/Search', params)
  }

  async getById(id: number): Promise<ApiResult<NewsletterFileBase>> {
    return this.instance.get(`/NewsletterFile/${id}`)
  }

  async getTemporaryUrl(id: number): Promise<ApiResult<string>> {
    return this.instance.get(`/NewsletterFile/GetTemporaryUrl/${id}`)
  }

  async create(data: NewsletterFileCreateDto): Promise<ApiResult<idItem>> {
    const formData = new FormData()

    formData.append('name', data.name)
    formData.append('agreementDate', data.agreementDate)
    formData.append('creationMonth', data.creationMonth)
    formData.append('pdf', data.pdf)

    return this.instance.post('/NewsletterFile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  async update(data: NewsletterFileUpdateDto): Promise<ApiResult<idItem>> {
    const formData = new FormData()

    formData.append('id', data.id.toString())
    if (data.name) formData.append('name', data.name)
    if (data.agreementDate)
      formData.append('agreementDate', data.agreementDate.toISOString().split('T')[0])
    if (data.creationMonth) formData.append('creationMonth', this.toYYYYMM01(data.creationMonth))
    if (data.pdf) formData.append('pdf', data.pdf)

    return this.instance.put('/NewsletterFile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  async delete(id: number): Promise<ApiResult<idItem>> {
    return this.instance.delete(`/NewsletterFile/${id}`)
  }

  toYYYYMM01(date: Date): string {
    const safe = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 1, 12))
    return safe.toISOString().split('T')[0]
  }
}

type NewsletterFileBase = {
  id: number
  name: string
  agreementDate: string | Date
  creationMonth: string | Date
  filePath: string
  originalFileName?: string
}

type NewsletterFileSearch = {
  page: number
  limit: number
  name?: string
  agreementDate?: string
  creationMonth?: string
  originalFileName?: string
  orderByDes?: boolean
  sortBy?: NewsletterFileSortableKey
}

enum NewsletterFileSortableKey {
  Id = 'Id',
  Name = 'Name',
  AgreementDate = 'AgreementDate',
  CreationMonth = 'CreationMonth',
  OriginalFileName = 'OriginalFileName',
}

type NewsletterFileCreateDto = {
  name: string
  agreementDate: string
  creationMonth: string
  pdf: File
}

type NewsletterFileUpdateDto = {
  id: number
  name?: string
  agreementDate?: Date
  creationMonth?: Date
  pdf?: File
}

export {
  NewsletterFileBase,
  NewsletterFileSearch,
  NewsletterFileSortableKey,
  NewsletterFileCreateDto,
  NewsletterFileUpdateDto,
}
